// extracted by mini-css-extract-plugin
export default {"tacContainer":"TermsAndConditions_tacContainer__Na2B1","bold":"TermsAndConditions_bold__INwlW","caps":"TermsAndConditions_caps__CcdJ9","normal":"TermsAndConditions_normal__qbgUP"};